document.addEventListener('DOMContentLoaded', () => {
  const animatedItems = document.querySelectorAll('.animated-item');

  const round = (num, decimals = 2) => {
    const factor = Math.pow(10, decimals);
    return Math.round(num * factor) / factor;
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const animation = el.dataset.animation || 'fade-up';
        const rawDelay = parseFloat(el.dataset.animationDelay || 0);
        const delay = isNaN(rawDelay) ? 0 : round(rawDelay, 2);

        el.style.setProperty('--animation-delay', `${delay}s`);
        el.classList.add(animation);
        observer.unobserve(el);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px 50px 0px'

  });

  animatedItems.forEach(item => {
    observer.observe(item);
  });
});
